import type { CalculatorInput } from "@/shared/lib/staffing-shared"
import {
  periodOptions,
  reportingIntervalOptions,
  resolvePeriodSeconds,
} from "@/shared/lib/staffing-shared"

import type { CalculatorFormValues } from "./types"

export const DEFAULT_FORM_VALUES: CalculatorFormValues = {
  incomingContacts: "",
  period: periodOptions[1]?.value ?? periodOptions[0]?.value ?? "30m",
  averageHandleTimeSeconds: "",
  requiredServiceLevel: "",
  targetAnswerTimeSeconds: "",
  shrinkage: "30",
  maxOccupancy: "85",
  averagePatienceSeconds: "60",
  workingHoursPerWeek: "37.5",
  reportingInterval:
    reportingIntervalOptions[1]?.value ?? reportingIntervalOptions[0]?.value ?? "30min",
}

export const mapFormValuesToInput = (values: CalculatorFormValues): CalculatorInput => ({
  incomingContacts: Number(values.incomingContacts),
  periodSeconds: resolvePeriodSeconds(values.period),
  averageHandleTimeSeconds: Number(values.averageHandleTimeSeconds),
  targetServiceLevelPercent: Number(values.requiredServiceLevel),
  targetAnswerTimeSeconds: Number(values.targetAnswerTimeSeconds),
  shrinkagePercent: Number(values.shrinkage),
  maxOccupancyPercent: Number(values.maxOccupancy),
  averagePatienceSeconds: Number(values.averagePatienceSeconds),
})

export const getPeriodLabelKey = (periodValue: string): string => {
  const match = periodOptions.find((option) => option.value === periodValue)
  return match?.labelKey ?? periodOptions[0]?.labelKey ?? "form.periodOptions.fallback.label"
}

export const getPeriodDescriptorKey = (periodValue: string): string => {
  const match = periodOptions.find((option) => option.value === periodValue)
  return (
    match?.descriptorKey ??
    periodOptions[0]?.descriptorKey ??
    "form.periodOptions.fallback.descriptor"
  )
}

export { calculatorFormSchema, validateField, validateForm } from "./validation"
